import { useEffect } from "react";

export const useMenuHandler = (navbarRef, closeMenu) => {
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target) &&
        document.querySelector(".navbar-collapse").classList.contains("in")
      ) {
        closeMenu();
      }
    };

    const handleScrollClose = () => {
      closeMenu();
    };

    window.addEventListener("click", handleOutsideClick);
    window.addEventListener("scroll", handleScrollClose);

    return () => {
      window.removeEventListener("click", handleOutsideClick);
      window.removeEventListener("scroll", handleScrollClose);
    };
  }, [navbarRef, closeMenu]);
};
